export enum ScheduleRestrictionType {
    // Отгул
    TimeOff = 0,
    // Отпуск
    Vacation = 1,
    // Больничный
    StickLeave = 2,
    // Праздник
    Holiday = 3,
    // Другое
    Other = 99
}